// Lib
import React from 'react';

// Components
import Button from '../../../components/buttons/Button';
import Icon from '../../../components/icons/Icon';

// Constants
import { NavigationDetail } from '../templateTypes';

const BoardTemplatePickerHeader = ({
    navigation,
    setNavigation,
}: {
    navigation: NavigationDetail;
    setNavigation: (navigation: NavigationDetail) => void;
}) => {
    if (navigation.level > 0) {
        return (
            <Button className="header-nav back-button" onClickFn={() => setNavigation({ level: navigation.level - 1 })}>
                <Icon name="chevron-left" />
                Back
            </Button>
        );
    }

    return <h3 className="header-nav">Choose a template</h3>;
};

export default BoardTemplatePickerHeader;
